<template>
    <div>
        <el-button size="small" v-permission="'Company:ThirdPartiesSkip'" @click="_onClick">第三方跳转</el-button>
        <el-dialog title="第三方跳转" :visible.sync="dialogVisible" append-to-body>
            <el-button type="primary" icon="el-icon-plus" @click="_onClickinner" style="margin-bottom: 20px;">添加系统</el-button>
            <el-table :data="tableData" border max-height="500" show-overflow-tooltip>
                <el-table-column prop="systemName" label="系统名称" >
                </el-table-column>
                <el-table-column prop="link" label="跳转链接" >
                </el-table-column>
                <el-table-column label="操作" >
                    <template slot-scope="scope">
                        <el-button size="small" @click="_edit(scope)" type="primary">编辑</el-button>
                        <el-button size="small" @click="_delete(scope)" type="danger">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <el-dialog :title="innerDialogTitle" width="500px" :visible.sync="innerDialogVisible" append-to-body>
                <el-form ref="formRef" hide-required-asterisk label-position="top" :model="form" :rules="rules" label-width="100px" class="demo-form-inline">
                    <el-form-item label="系统名称" prop="systemName">
                        <el-input v-model="form.systemName" autocomplete="off" />
                    </el-form-item>
                    <el-form-item label="跳转链接" prop="link">
                        <el-input v-model="form.link" autocomplete="off" />
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="_submitForm">确 定</el-button>
                        <el-button type="default" @click="_closeDialog">取 消</el-button>
                    </el-form-item>
                </el-form>
            </el-dialog>
        </el-dialog>
    </div>
</template>

<script>
import {ThirdPartiesSkip,CompanyDetails} from '@/api/companyManagement/Company.js'
export default {
  props:{
    row:{
        type:Object,
        default:()=>{}
    }
  },
  data() {
    return {
        dialogVisible:false,
        innerDialogVisible:false,
        tableData: [],
        form:{
            systemName:'',
            link:''
        },
        rules:{
            systemName: [{ required: true, message: '请输入系统名称', trigger: 'blur' }],
            link: [{ required: true, message: '请输入跳转链接', trigger: 'blur' }],
        },
        innerDialogTitle:'添加系统',
        innerDialogIndex:null,
    };
  },
  methods:{
    _onClick(){
        this.dialogVisible = true
        this._getDetails()
    },
    //详情列表Api
    async _getDetails(){
        const reslut = await CompanyDetails({Id:this.row.Id})
        if(reslut.data.Code == 200){
            this.tableData = reslut.data.Data.Data.ThirdPartiesSkip || []
        }
    },
    //新增
    _onClickinner(){
        this.innerDialogIndex = null
        this.innerDialogVisible = true
        this.innerDialogTitle = '添加系统'
        this.form = {
            systemName:'',
            link:''
        }
        this._resetForm()
    },
    // 编辑
    _edit(scope){
        let self = this
        this.innerDialogIndex = scope.$index
        this.innerDialogTitle = '编辑系统'
        this.innerDialogVisible = true
        self.form = JSON.parse(JSON.stringify(scope.row))
        this._resetForm()
    },
    // 删除
    _delete(scope){
        this.$confirm('确认删除吗？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
        }).then(async () => {
            let {Id} = this.row
            let data = {
                Id,
                T_skip:JSON.stringify(this.tableData.filter(item=>item.systemName != scope.row.systemName))
            }
            const reslut = await this.thirdPartiesSkip(data)
            if(reslut.data.Code == 200){
                // this.tableData = this.tableData.filter(item=>item.systemName != scope.row.systemName)
                this._getDetails()//更新拉取数据
                this.$message.success('操作成功')
            }
        })
    },
    
    async _submitForm(){
        await this.$refs.formRef.validate(async (valid) => {
            if (valid) {
                let {Id} = this.row
                let arrayData = [...this.tableData]
                //编辑时替换
                console.log(' 编辑时替换 ',this.innerDialogIndex,arrayData,this.form);

                if(this.innerDialogIndex != null){
                    arrayData[this.innerDialogIndex] = this.form
                }else{//新增时追加
                    arrayData.push(this.form)
                }
                let data = {
                    Id,
                    T_skip:JSON.stringify(arrayData)
                }
                const reslut = await this.thirdPartiesSkip(data)
                if(reslut.data.Code == 200){
                    // this.tableData = JSON.parse(JSON.stringify(arrayData))
                    this._getDetails()//更新拉取数据
                    this.$message.success(this.innerDialogTitle == '添加系统'?'添加成功':'编辑成功')
                    this.innerDialogVisible = false
                }
            } else {
                return false;
            }
        });
    },
    _resetForm(){
        if(this.$refs.formRef){
            this.$refs.formRef.resetFields();
        }
    },
    _closeDialog(){
        this.innerDialogVisible = false
    },
    // 第三方跳转提交接口
    async thirdPartiesSkip(data){
        return new Promise((resolve, reject) => {
            ThirdPartiesSkip(data).then(res=>{
                resolve(res)
            })
        })
    },
  },
};
</script>
<style lang="scss">
/* @import url(); 引入css类 */
</style>
